<template>
  <div class="flex pl-5 pt-4 relative z-30">
    <transition name="fade" mode="out-in">
      <div class="hidden md:flex md:flex-shrink-0">
            <div class="w-12 flex-1 flex flex-col">
              <nav-dropdown class="builder-logo bg-secondary-dark hidden sidebar-shadow" :logo="logo" />
              <div
                :id="origin == appShortUrl ? 'no_fill_sidebar' : 'left_sidebar'"
                class="bg-secondary-darker mt-4 sidebar-shadow"
              >
                <nav
                  aria-label="Sidebar"
                  class="
                    hidden
                    md:block
                    md:flex-shrink-0
                    md:overflow-y-auto
                    h-full
                    justify-between
                    flex flex-col
                  "
                >
                  <div class="flex flex-col p-2 space-y-2">
                    <div
                      v-for="slot in slots"
                      v-show="slot.icon"
                      :id="slot.id"
                      :key="slot.name"
                      class="
                        cursor-pointer
                        hover:bg-secondary
                        flex-shrink-0
                        inline-flex
                        items-center
                        justify-center
                        h-8
                        w-8
                        rounded-lg
                        text-secondary-invert
                        mx-auto
                      "
                      :class="[
                        {
                          activeSideBar: openSection === slot.name,
                          'text-secondary-invert': openSection != slot.name,
                        },
                        slot.name.toLowerCase().replaceAll(' ', ''),
                      ]"
                      @click.stop="setOpen(slot.name)"
                      v-tooltip="{
                        content: slot.name,
                        placement: 'right',
                        classes: ['builder-sidebar-tooltip'],
                      }"
                    >
                      <component
                        :is="slot.icon"
                        class="h-5 w-5 cursor-pointer"
                      />
                    </div>
                  </div>
                </nav>
              </div>
            </div>
      </div>
    </transition>
    <div class="bg-secondary-darker flex flex-col sidebar-shadow overflow-hidden absolute left-0 top-0 mt-8 z-20" style="left: 76px;" v-on-click-outside="close">
      <transition name="fade" mode="out-in">
        <div v-for="section in openSections" :key="section.name">
          <div
            v-if="section.doNotOpen !== 1"
            style="min-width: 340px;max-width: 340px;"
          >
            <div
              class="
                heading
                border-solid border-secondary border-b
                flex flex-row
                justify-between
                h-16
                px-5
              "
            >
              <div v-if="isBlock" class="flex flex-column items-center z-10">
                <span class="flex flex-grow gap-2">
                  <text-input
                    variant="black"
                    v-model="inputTitle"
                  />
                  
                  <gd-button
                    variant="primary"
                    size="icon"
                    class="h-10 w-10"
                    @click="saveRenameBlock()"
                  >
                    <CheckIcon class="h-4 w-4"/>
                  </gd-button>
                </span>
              </div>
              <div v-else class="flex flex-column items-center z-10">
                <slot name="header"></slot>
              </div>
              <div class="flex flex-column items-center cursor-pointer">
                <slot :name="section.slot + '_header'"></slot>
                <CloseIcon class="h-6 w-6 text-secondary-invert" @click="close()" />
              </div>
            </div>
            <hr class="border-t border-secondary-light" />
            <div
              v-if="showSubTitle"
              class="text-secondary-invert text-xs font-bold px-4 mt-6 uppercase"
            >
              {{ section.name }}
            </div>
            
            <div
              style="min-height: 300px; max-height: calc(100vh - 160px);"
              class="
                overflow-y-auto
                flex flex-col flex-grow
                custom-scrollbars
                text-sm
              "
            >
              <slot v-if="section.slot" :name="section.slot"></slot>
              <component :is="section.component" v-if="section.component" />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <transition name="sidebarFade" mode="out-in">
      <side-bar-left v-if="menuOpenLeft" @closeSideBar="showCloseSideBar" />
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import MultiLevelDropdown from '@groovepages/gd-ui-kit/components/MultiLevelDropdown';
import SideBarLeft from '@groovepages/gd-ui-kit/components/SideBarLeft';
import FeedbackMenu from '@groovepages/gd-ui-kit/components/FeedbackMenu';
import directives from '@groovepages/gd-ui-kit/directives';
import AcademyMenu from '@groovepages/gd-ui-kit/components/AcademyMenu';
import SupportMenu from '@groovepages/gd-ui-kit/components/SupportMenu';
import NavDropdown from '../design-system/nav-dropdown-adapter';

// import brands icons
import GdLogo from '@groovepages/gd-ui-kit/assets/logo-extra-small.svg';
import GroovePagesLogo from '@groovepages/gd-ui-kit/assets/groovepages-logo-small.svg';
import GrooveSellLogo from '@groovepages/gd-ui-kit/assets/groovesell-logo-small.svg';
import GrooveAffiliateLogo from '@groovepages/gd-ui-kit/assets/grooveaffiliate-logo-small.svg';
import GrooveMailLogo from '@groovepages/gd-ui-kit/assets/groovemail-logo-small.svg';
import GrooveMemberLogo from '@groovepages/gd-ui-kit/assets/groovemember-logo-small.svg';
import GrooveVideoLogo from '@groovepages/gd-ui-kit/assets/groovevideo-logo-small.svg';
import GrooveBlogLogo from '@groovepages/gd-ui-kit/assets/grooveblog-logo-small.svg';
import GrooveWebinarLogo from '@groovepages/gd-ui-kit/assets/groovewebinar-logo-small.svg';
import GrooveKartLogo from '@groovepages/gd-ui-kit/assets/groovekart-logo-small.svg';

// import icons from gd-ui-kit
import FeedbackIcon from '@groovepages/gd-ui-kit/assets/feedback-icon.svg';
import AcademyIcon from '@groovepages/gd-ui-kit/assets/academy-icon.svg';
import SupportIcon from '@groovepages/gd-ui-kit/assets/support-icon.svg';

// import icons
import CloseIcon from '@/assets/images/icons/new/close_small_new.svg';
import CheckIcon from '@/assets/images/icons/new/check_new.svg';

export default {
  name: 'SideBar',
  directives,
  components: {
    NavDropdown,
    CloseIcon,
    MultiLevelDropdown,
    CheckIcon,
    SideBarLeft,
    FeedbackIcon,
    FeedbackMenu,
    AcademyIcon,
    AcademyMenu,
    SupportIcon,
    SupportMenu,
    GroovePagesLogo,
    GrooveSellLogo,
    GrooveAffiliateLogo,
    GrooveMailLogo,
    GrooveMemberLogo,
    GrooveVideoLogo,
    GrooveBlogLogo,
    GrooveWebinarLogo,
    GrooveKartLogo,
    GdLogo,
  },
  props: {
    closeIcon: {
      default: 'CloseIcon',
    },
    initialOpen: {},
    sections: {},
    title: {},
    double: {},
    fixed: {},
    noExitButton: { default: false },
    isBlock: { default: false },
    noContent: { default: false },
    editBlockTitle: {},
    componentId: {},
    origin: { default: 'GroovePages' },
    logo: {},
    showSubTitle: { default: true },
  },
  data() {
    return {
      appShortUrl: '',
      hoveredCategory: '',
      hoveredApps: [],
      showChildSidebar: false,
      openSection: null,
      slots: [],
      menuOpenLeft: false,
      renamingBlock: false,
      inputTitle: '',
      nativeMenus: [
        {
          name: this.$t('frontend_sites_side_bar_groovedigital_academy'),
          icon: AcademyIcon,
          component: AcademyMenu,
        },
        {
          name: this.$t('frontend_sites_side_bar_left_heldesk'),
          icon: SupportIcon,
          component: SupportMenu,
        },
        {
          name: this.$t('frontend_feedback'),
          icon: FeedbackIcon,
          component: FeedbackMenu,
        },
      ],
    };
  },
  computed: {
    brandData() {
      return this.$store.getters.brandData;
    },

    multiSection() {
      return Array.isArray(this.sections);
    },
    openSections() {
      return [...this.slots, ...this.nativeMenus].filter(
        (section) => section.name === this.openSection
      );
    },
    customTitle() {
      return this.inputTitle || this.title;
    },
    correctedOpenSection() {
      if (this.openSection === 'Edit Popup') return 'Popups';

      return this.openSection;
    },
    activePopup() {
      return this.$store.getters['popups/activePopup'];
    },
    modified() {
      return this.$store.state?.builder?.modified;
    },
  },
  created() {
    this.setSlots();
  },
  mounted() {
    this.appShortUrl = this.$store.getters.appName;
  },
  methods: {
    setSlots() {
      if (this.multiSection) {
        this.slots = this.sections.map((section) => ({
          ...section,
          slot: section.name,
        }));
      } else {
        this.slots = [{ name: this.sections, slot: 'default' }];
      }

      if (this.multiSection && this.initialOpen) {
        const openSectionObject = this.slots.find(
          (slot) => slot.name === this.initialOpen
        );

        this.openSection = this.initialOpen;
      } else if (typeof this.initialOpen !== 'undefined') {
        this.openSection = this.sections;
      }
    },
    hideAllDropdowns(resolve) {
      for (let i = 0; i < 10; i++) {
        if (this.$refs[`ml_dropdown_${i}`]) {
          this.$refs[`ml_dropdown_${i}`].isHidden = true;
        }
      }
      resolve(); // don't forget call resolve!
    },

    setOpen(name, isNativeMenu = false) {
      if (this.correctedOpenSection !== name) {
        const openSectionObject = this.slots.find((slot) => slot.name === name);

        this.openSection = null;

        if (!this.noContent || isNativeMenu) this.openSection = name;

        if (name === 'Popups' && this.activePopup && this.activePopup.pageId)
          this.openSection = 'Edit Popup';

        this.$nextTick(() => {
          this.$emit('open', name);
        });
      }
    },
    close() {
      const toClose = this.openSection;
      if (!this.openSection) return;
      this.openSection = null;
      this.renamingBlock = false;
      this.$nextTick(() => {
        this.$emit('close', toClose);
      });
    },
    open() {
      if (this.initialOpen) this.openSection = this.initialOpen;
      else if (this.multiSection) this.openSection = this.sections[0];
      else this.openSection = this.sections;
      this.$nextTick(() => {
        this.$emit('open', this.openSection);
      });
    },
    openLeftSidebar() {
      this.menuOpenLeft = true;
      this.openSection = null;
    },
    exit() {
      window.location.replace('/');
    },
    showCloseSideBar(payload) {
      this.menuOpenLeft = payload;
    },
    onMouseOver(name) {
      /** */
    },
    onMouseLeave(name) {
      /** */
    },
    renameBlock() {
      this.renamingBlock = true;
    },
    saveRenameBlock() {
      this.renamingBlock = false;
      this.$emit('editBlockTitle', this.inputTitle);
    },
    handleRedirect(e, url, target) {
      if (this.modified && target === '_self') {
        this.$store.commit('setRedirect', url);
        e.preventDefault();
      }
    },
  },
  watch: {
    title: {
      deep: true,
      handler(newValue, oldValue) {
        this.renamingBlock = false;
        if (oldValue !== newValue) this.inputTitle = newValue;
      },
    },
    sections: {
      handler(newValue, oldValue) {
        this.setSlots();
      }
    },
    componentId: {
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue !== newValue) this.renamingBlock = false;
      },
    },
  },
};
</script>

<style scoped>
.activeSideBar {
  color: var(--brand-primary);
}

.sidebar-shadow {
   box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
   border-radius: 6px;
}
</style>
<style lang="scss">
.builder-sidebar-tooltip {
  display: block !important;
  z-index: 10000;
  margin-left: 50px !important;
  .tooltip-inner {
    background: var(--brand-secondary);
    font-weight: 600;
    color: var(--brand-secondary-invert);
    border-radius: 8px;
    padding: 5px 20px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: var(--brand-secondary);
  }
  &[x-placement^='right'] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
.builder-logo {
  width: 48px;
  height: 48px !important;
  padding: 0;
  svg g {
    clip-path: url(#logo);
  }
}
</style>
